import { action } from '@ember/object';
import Component from '@ember/component';

export default class SharedDropZoneFileUpload extends Component {
  @action
  handleClick(evt) {
    this.onClick?.(evt);
  }
}
